module.exports = __webpack_public_path__ + "img/step-icon-ready.91e08609.svg";